export const EventTileOverlay = () => (
  <div className="tile-overlay">
    <div className="overlay-content">&nbsp;</div>
  </div>
);
